import { ExitGameModal } from '@shared'

export default function ExitPuzzleModal ({ onClose, onExit, imageSrc }) {
  return (
    <ExitGameModal
      onClose={onClose}
      onExit={onExit}
      imageSrc={imageSrc}
      imageSquare
    />
  )
}
